import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';

import {
  IOrderItems,
  IOrderTransferInterface,
} from '../../interfaces/order-transfers.interface';

@Component({
  selector: 'lum-order-transfer-line-items',
  templateUrl: './order-transfer-line-items.component.html',
  styleUrls: ['./order-transfer-line-items.component.scss'],
})
export class OrderTransferLineItemsComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data :any,
    private dialogRef :MatDialogRef<OrderTransferLineItemsComponent>,
  ) {}

  ngOnInit() :void {}

  onClose() :void {
    this.dialogRef.close();
  }

  get orderItems() :IOrderItems[] {
    return this.data.orderTransfer?.orderItems || [];
  }
}
